import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { UserGuide } from '@/features/content/Guide';
import { MobileUserGuide } from '@/features/content/mobile/MobileUserGuide';

export const Route = createFileRoute('/_app/user-guide')({ component: UserGuideRoute });

/** Selettore: guida utente mobile (MaeDesign) vs lettore documenti desktop. */
function UserGuideRoute() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileUserGuide /> : <UserGuide />;
}
